import React from 'react'
import PropTypes from 'prop-types'
import { domains } from '../lib/config'
const { CDN_DOMAIN } = domains

class Notification extends React.Component {
  static propTypes = {
    id: PropTypes.number,
    text: PropTypes.string,
    fade: PropTypes.bool,
    color: PropTypes.oneOf(['question', 'info', 'success', 'warning', 'danger'])
      .isRequired,
    showIdon: PropTypes.bool,
    dismissed: PropTypes.bool,
    dismissable: PropTypes.bool,
    autoDismissTimeout: PropTypes.number,
    shadow: PropTypes.bool,
    onDismiss: PropTypes.func,
    clearBackground: PropTypes.bool,
  }
  static defaultProps = {
    fade: true,
    showIcon: true,
    dismissed: false,
    dismissible: false,
    autoDismissTimeout: 0,
    shadow: false,
    clearBackground: false,
  }

  static pngs = {
    question: `${CDN_DOMAIN}/assets/img/question_icon_32px.png`,
    info: `${CDN_DOMAIN}/assets/img/info_icon_32px.png`,
    success: `${CDN_DOMAIN}/assets/img/success_icon_32px.png`,
    warning: `${CDN_DOMAIN}/assets/img/yield_icon_32px.png`,
    danger: `${CDN_DOMAIN}/assets/img/warning_icon_32px.png`,
    close: `${CDN_DOMAIN}/assets/img/cross_icon.png`,
  }

  constructor(props) {
    super(props)

    this.state = {
      show: true,
      dismissTimeout: null,
    }
  }

  componentDidMount = () => {
    const { dismissible, autoDismissTimeout } = this.props
    if (dismissible && autoDismissTimeout > 0) {
      this.setDismissTimeout(this.props.autoDismissTimeout)
    }
  }

  componentWillUnmount = () => {
    const { dismissTimeout } = this.state
    if (dismissTimeout) {
      clearTimeout(dismissTimeout)
      this.setState({ dismissTimeout: null })
    }
  }

  setDismissTimeout = (ttl = 500) => {
    const { onDismiss } = this.props
    const timeout = setTimeout(() => {
      this.setState({ dismissed: true }, onDismiss)
    }, ttl)
    this.setState({ dismissTimeout: timeout })
  }

  dismiss = () => {
    this.setState({ show: false }, this.setDismissTimeout)
  }

  render = () => {
    const { dismissed, show } = this.state
    let {
      fade,
      color,
      clearBackground,
      showIcon,
      text,
      dismissible,
      shadow,
      children,
    } = this.props
    const content = children || text

    if (dismissed) return null

    const icon = color
    color = clearBackground ? 'none' : color === 'question' ? 'info' : color

    const style = {}
    return (
      <div
        className={`notification-wrapper ${fade ? 'fade' : ''} ${
          show ? 'show' : ''
        }`}
      >
        <div
          className={`alert alert-${color} notification-alert`}
          style={style}
        >
          {showIcon && <div className="img" />}
          <div className="message">{content}</div>
          {dismissible && (
            <div className="dismiss-container" onClick={this.dismiss}>
              <div className="dismiss">
                <span className="dismiss-link">Dismiss</span>&nbsp;&nbsp;
                <i className="fas fa-times" />
              </div>
            </div>
          )}
        </div>

        <style jsx>
          {`
            .notification-wrapper {
              ${shadow
                ? 'box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);'
                : ''}
            }

            .notification-alert {
              display: flex;
              align-content: flex-start;
              padding: 1.12rem 1.5rem;
              font-size: 1.125rem;
              line-height: 1.5rem;
              border: none;
            }

            .notification-alert > * {
              display: flex;
              align-content: center;
              color: #1f1f1f !important;
            }

            .notification-alert .img {
              background-image: url(${Notification.pngs[icon]});
              background-repeat: no-repeat;
              width: 2rem;
              height: 2rem;
              padding-right: 3.4rem;
            }

            .notification-alert .message {
              flex-grow: 1;
              margin-top: 0.1875rem;
              ${dismissible ? 'padding-right: 3.75rem;' : ''}
              display: block;
            }

            .notification-alert .dismiss-container {
              display: flex;
              margin-top: 3px;
              white-space: nowrap;
              cursor: pointer;
            }

            .notification-alert .dismiss-link {
              font-weight: bold;
              text-decoration: underline;
            }

            .notification-alert .fa-times {
              display: inline-block;
              vertical-align: middle;
            }
          `}
        </style>
      </div>
    )
  }
}

export default Notification



// WEBPACK FOOTER //
// ./src/components/Notification.js